import { api } from '@api/api';
import { Option } from '@api/types/option';

const adminTagApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAdminCompanyTags: build.query<Option[], void>({
      query: () => ({
        url: 'admin/tag/companylinkedoptions',
      }),
    }),
  }),
});

export const { useGetAdminCompanyTagsQuery } = adminTagApi;
